<template>
    <div class="space-y-8">
        <div class="space-y-4 text-center">
            <h3 class="text-4xl font-semibold">#store</h3>
            <p>
                Find us on Instagram and see how our customers style their
            </p>
        </div>
        <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div v-for="post in instagramPosts" :key="post.id" class="group">
                <a :href="post.link" target="_blank" rel="noopener noreferrer" class="relative block">
                    <img :src="post.image" :alt="post.caption" class="aspect-square object-cover" />
                    <div class="absolute inset-0 bg-black/25 opacity-0 group-hover:opacity-100 transition-opacity">
                    <UIcon
                        name="i-simple-icons:instagram"
                        class="absolute top-[50%] start-[50%] -translate-x-[50%] -translate-y-[50%] text-white text-4xl opacity-0 group-hover:opacity-100 transition-opacity"
                    />
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
const instagramPosts = [
    {
        id: 1,
        image: 'https://picsum.photos/seed/sneakers5/800/800',
        caption: 'Post 1',
        link: 'https://www.instagram.com/p/POST1'
    },
    {
        id: 2,
        image: 'https://picsum.photos/seed/sneakers5/800/800',
        caption: 'Post 2',
        link: 'https://www.instagram.com/p/POST2'
    },
    {
        id: 3,
        image: 'https://picsum.photos/seed/sneakers5/800/800',
        caption: 'Post 3',
        link: 'https://www.instagram.com/p/POST3'
    },
    {
        id: 4,
        image: 'https://picsum.photos/seed/sneakers5/800/800',
        caption: 'Post 4',
        link: 'https://www.instagram.com/p/POST4'
    }
]
</script>